export const commonLanguageFiles = ['links', 'common','trust-pilot'];